import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    get productAPIUrls(): any {
        return {
            dataUrl : `${this.dataCollectorService.baseurl()}/product/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/product/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/product/meta/filter`,
            bulkActionUrl: `${this.dataCollectorService.baseurl()}/products/bulk_action`,
            noteAttachmentUrl: `${this.dataCollectorService.baseurl()}/note_attachment`,
            locationUrl: `${this.dataCollectorService.baseurl()}/products/location`,
            productCategoryUrl: `${this.dataCollectorService.baseurl()}/products/category`,
            productTransactionUrl: `${this.dataCollectorService.baseurl()}/product/transaction`
        };
    } 
    productDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentProductDetails = new BehaviorSubject(null);

    constructor(private dataCollectorService: DataCollectorService) {
        this.productDetailsLoaded.next(false);
    }

    actionUrl(productId: string): string{
        return `${this.dataCollectorService.baseurl()}/product/${productId}`;
    }

    getProductDetails(productId: string): string {
        return `${this.dataCollectorService.baseurl()}/product/${productId}`;
    }

    getProductNotes(productId: string): string {
        return `${this.dataCollectorService.baseurl()}/notes`;
    }

    productTransaction(productId: string, transactionType: string): string {
        return `${this.dataCollectorService.baseurl()}/product/${productId}/${transactionType}`;
    }

    productURL(): string {
        return `${this.dataCollectorService.baseurl()}/product`;
    }
}
